<template>
  <li class="list-item" v-if="url">
    <a
      :href="url"
      class="list-item__content"
    >
      <section class="list-item__col-1">
        <h2 class="list-item__heading">{{ title }}</h2>
        <p class="list-item__desc">{{ desc }}</p>
      </section>
      <section
        class="job-listing__details"
        :class="{ 'job-listing__details--one-col-mobile': !commitment || !location }"
    >
        <span
            v-if="commitment"
            class="job-listing__details-commitment"
            :class="{ 'job-listing__details-commitment--no-divider': !location }"
        >
          {{ commitment }}
        </span>

        <span
            class="job-listing__details-location"
            v-if="location"
        >
            {{ location }}
        </span>
      </section>
    </a>
  </li>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    commitment: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
@use 'mixins' as *;
@use 'variables';

.job-listing__details {
  position: relative;
  display: grid;
  grid-template-areas: 'commitment location';
  grid-template-columns: 80px 1fr;
  align-items: center;
  width: 100%;
  margin-top: 0.5rem;
  color: variables.$color-gray-3;
  font-weight: 600;
  column-gap: 1.5rem;

  &--one-col-mobile {
    @include mobile-only {
      display: block;
    }
  }

  @include breakpoint-md {
    margin-top: 0;
  }

  &-commitment {
    position: relative;
    grid-area: commitment;

    &:after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      height: 1rem;
      width: 1px;
      transform: translateY(-50%);
      background: #d8d8d8;
    }

    &--no-divider:after {
      display: none;
    }
  }

  &-location {
    grid-area: location;
  }
}

.list-item {
  background-color: transparent;
  border-radius: 10px;
  margin-bottom: 3px;
  list-style: none;
  position: relative;
  transition: 200ms ease all;

  @include breakpoint-md {
    &:hover, &:focus {
      background-color: variables.$color-white;
      box-shadow: rgba(0, 0, 0, 0.25) 0 7px 28px;
      z-index: 1;

      .list-item__desc::after {
        background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), variables.$color-white 1.5em);
      }
    }
  }

  &__heading {
    text-transform: uppercase;
    font-size: 1.25em;
    margin-bottom: 0;
    margin-top: 0;
    transition: 200ms ease all;
    font-weight: bold;
    color: variables.$color-gray-5;
  }

  &__desc {
    position: relative;
    margin-top: 0.4rem;
    margin-bottom: 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 1em;

    &::after {
      content: 'Read More';
      background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), variables.$color-gray-1 1.5em);
      color: currentColor;
      text-decoration: underline;
      position: absolute;
      right: 0;
      bottom: 0;
      padding-left: 1.5rem;

      @media (hover: none) and (pointer: coarse) {
        line-height: 1.2;
      }

      @include breakpoint-md {
        line-height: unset;
      }
    }
  }

  &__col-1 {
    box-sizing: border-box;
    color: variables.$color-gray-3;

    @include breakpoint-md {
      flex: 0 0 50%;
      padding-right: 1rem;
    }

    @include breakpoint-lg {
      flex: 0 0 70%;
      padding-right: 3rem;
    }
  }

  &__content {
    position: relative;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 1.5rem 0;
    transition: 200ms ease all;
    box-sizing: border-box;
    text-decoration: none;

    &:hover, &:focus {
      text-decoration: none;
      z-index: 1;
    }

    @include breakpoint-md {
      padding: 1.5rem;
      flex-direction: row;
      align-items: center;
    }
  }
}
</style>
